import api, { METHODS } from './api'
import { ResponseType } from '../common/types/api/request'

export default async function setCustomSendSmtpDelay(delayMs: number): Promise<ResponseType> {
    try {
        const res = await api<ResponseType>(
            `customSendSmtpDelay`, // for apache servers
            METHODS.POST,
            `${delayMs}`
        )

        if (res.error) {
            console.error("Error trying to save new SMTP delay between sends in reports-maker", res.error)

            return {
                success: false,
                error: res.error
            }
        }

        return res
        
    } catch (error) {
        // TODO: use logger
        // console.error(error)
        console.error("Error trying to save new SMTP delay between sends in reports-maker", error)
        return {
            success: false,
            error: error
        }
    }
}